import React from "react";
import PropTypes from "prop-types";
import Modal from "../Modal/Modal";

const ModalPhoneTwoFactorAuthentication = ({ show, onConfirm }) => (
	<div className="modal-phone-two-factor-authentication">
		<Modal
			title="Emissão será apenas em horário comercial"
			description={"A emissão das passagens será apenas de 8h às 22h. Com isso, pode ser que sua oferta demore um pouco mais a ser vendida."}
			confirm="Continuar"
			show={show}
			onConfirm={onConfirm}
			fixed={true}
			withoutClose={false}
			width={490}
		/>
	</div>
);

ModalPhoneTwoFactorAuthentication.propTypes = {
	show: PropTypes.bool.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default ModalPhoneTwoFactorAuthentication;
